export default {"src":"/_next/static/media/c2c-vehicle-details.68564490.svg","height":270,"width":345,"blurWidth":0,"blurHeight":0};